import React, { useState } from 'react';
import { Box, TableBody, TableCell, TableRow } from '@mui/material';
import axios from 'axios';
import Add from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import useDebounce from '../../../../hooks/useDebounce';
import { TableCustom, StatePagination } from '../../../../components/common';
import formatDate from '../../../../components/common/formatDate';
import { CustomIconButton } from '../../../../components/common/button/CustomIconButton';
import StateCustomTable from '../../../../components/common/StateCustomTable';
import { constants } from '../constant';

const tableHeaderObj = [
  [
    { text: '#', rowspan: 1, colspan: 1 },
    { text: 'Item Number', rowspan: 1, colspan: 1 },
    { text: 'Item Name/Description', rowspan: 1, colspan: 1 },
    { text: 'Vendor 1', rowspan: 1, colspan: 1 },
    { text: 'Vendor 2', rowspan: 1, colspan: 1 },
    { text: 'Vendor 3', rowspan: 1, colspan: 1 },
    { text: 'Created At', rowspan: 1, colspan: 1 },
    { text: 'Action', rowspan: 1, colspan: 1 },
  ],
];

const filterOptions = [{ value: 'part_number', name: 'A-Z' }];

const PartTable = (props: any) => {
  const { data, supplierId, removePart, addPart } = props;
  const [page, setPage] = useState(1);
  const [partData, setPartData] = useState<any[]>([]);
  const [perPage, setPerPage] = useState();
  const [totalPages, setTotalPages] = useState(0);
  const [search, setSearch] = useState<string>('');
  const [filter, setFilter] = useState<string>('part_number');
  const fetchPartData = () => {
    axios
      .get(
        `${
          constants.api.crud
        }/getpart/supplier/${supplierId}?page=${page}&sortBy=${filter}&search=${search}&perPage=${10}`
      )
      .then((res) => {
        setPerPage(res.data?.perPage);
        setPartData(res.data?.result);
        setTotalPages(res.data?.pages);
      })
      .catch((err) => console.log(err));
  };

  useDebounce(fetchPartData, 300, [page, filter, search]);

  return (
    <Box>
      <StateCustomTable
        filterOptions={filterOptions}
        {...{ search, setSearch, filter, setFilter }}
        label="Search Part"
      >
        <TableCustom tableHeaderObj={tableHeaderObj}>
          <TableBody>
            {partData &&
              partData.map((item: any, index: number) => (
                <React.Fragment key={item?._id}>
                  <TableRow>
                    <TableCell align="center">{index + 1}</TableCell>
                    <TableCell align="center">{item.part_number}</TableCell>
                    <TableCell align="center">{item.part_name}</TableCell>
                    <TableCell align="center">
                      {item?.vendor_id?.vender_name}
                    </TableCell>
                    <TableCell align="center">
                      {item?.vendor_id_2?.vender_name}
                    </TableCell>
                    <TableCell align="center">
                      {item?.vendor_id_3?.vender_name}
                    </TableCell>
                    <TableCell align="center">
                      {formatDate(item?.createdAt || '')}
                    </TableCell>
                    <TableCell align="center">
                      {data.ri_part_id === item._id ? (
                        <CustomIconButton
                          sx={{ p: 0 }}
                          tooltipTitle={'remove'}
                          onClick={removePart}
                        >
                          <RemoveIcon style={{ color: '#c92a2a' }} />
                        </CustomIconButton>
                      ) : (
                        <CustomIconButton
                          sx={{ p: 0 }}
                          tooltipTitle={'add'}
                          onClick={() => addPart(item)}
                        >
                          <Add style={{ color: '#343a40' }} />
                        </CustomIconButton>
                      )}
                    </TableCell>
                  </TableRow>
                </React.Fragment>
              ))}
          </TableBody>
        </TableCustom>
        <StatePagination page={page} totalPage={totalPages} setPage={setPage} />
      </StateCustomTable>
    </Box>
  );
};

export default PartTable;
